export default "__VITE_ASSET__0e1cb624__"